// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"7476dd5e","581":"59f9cb67"}[chunkId] + ".chunk.js";
};